import { useParams } from 'react-router-dom';
import { useLocaleNavigate } from '../../lib/hooks/use-locale-navigate';
import { useEffect, useMemo, useState } from 'react';
import useStella from '../../lib/hooks/use-stella';
import clsx from 'clsx';
import { useLocale } from '../../lib/context/locale-context';

const chzzkColorIcon = () => {
  return <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M55.7826 72H16.2174C7.26106 72 0 64.7389 0 55.7826V16.2174C0 7.26055 7.26106 0 16.2174 0H55.7826C64.7394 0 72 7.26055 72 16.2174V55.7826C72 64.7389 64.7394 72 55.7826 72Z" fill="black"/>
    <path d="M54.1298 55.9688V44.9464H37.5679L55.8028 19.7877H41.0269L45.501 13.6154H30.7246L18.5124 30.464H33.2888L14.8027 55.9688H54.1298Z" fill="#00FFA3"/>
  </svg>
}

const youtubeColorIcon = () => {
  return <svg width="90" height="64" viewBox="0 0 90 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.0261 45.0336L59.3646 31.4909L36.0261 18.014V45.0336ZM9.8613 61.1403C5.98242 60.0883 2.9583 56.9986 1.84071 53.1856C2.16453e-07 46.1512 0 31.4909 0 31.4909C0 31.4909 2.16453e-07 16.8306 1.84071 9.86196C2.9583 5.98331 5.98242 2.95896 9.8613 1.90719C16.8299 0.000663757 44.9671 0.000663757 44.9671 0.000663757C44.9671 0.000663757 73.1701 0.000663757 80.1389 1.90719C84.0834 2.95896 87.0417 5.98331 88.0937 9.86196C90 16.8306 90 31.4909 90 31.4909C90 31.4909 90 46.1512 88.0937 53.1856C87.0417 56.9986 84.0834 60.0883 80.1389 61.1403C73.1701 63.0469 44.9671 63.0469 44.9671 63.0469C44.9671 63.0469 16.8299 63.0469 9.8613 61.1403Z" fill="#FF0033"/>
    <path d="M36.0273 45.0352L59.3658 31.4924L36.0273 18.0155V45.0352Z" fill="white"/>
  </svg>
}

const xColorIcon = () => {
return <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M41.7325 31.7122L62.2075 8H57.3555L39.5771 28.589L25.3775 8H9L30.4726 39.1341L9 64H13.8522L32.6267 42.2574L47.6225 64H64L41.7313 31.7122H41.7325ZM35.0867 39.4084L32.9111 36.3082L15.6005 11.6391H23.0532L37.0231 31.5478L39.1987 34.6481L57.3578 60.5264H49.9052L35.0867 39.4096V39.4084Z" fill="black"/>
  </svg>
}

// 치지직 로고를 색상 변경 허용 받고 해당 아이콘들로 교체
// const chzzkIcon = () => {
//   return <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
//   <path d="M30.332 1.75H16.9154L5.54036 17.2083H19.2487L2.33203 40.25H38.207V30.3333H23.0404L39.6654 7.29167H26.2487L30.332 1.75Z" fill="currentColor" />
// </svg>
// }

// const youtubeIcon = () => {
//   return <svg width="59" height="42" viewBox="0 0 59 42" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
//   <path d="M57.7578 6.57344C57.0881 3.98125 55.0789 1.94688 52.5405 1.25781C47.9497 0 29.5 0 29.5 0C29.5 0 11.0503 0 6.44874 1.25781C3.91029 1.94688 1.91194 3.98125 1.23142 6.57344C1.19209e-07 11.2656 0 21.0437 0 21.0437C0 21.0437 1.19209e-07 30.8219 1.23142 35.5141C1.91194 38.0953 3.91029 40.0531 6.44874 40.7422C11.0503 42 29.5 42 29.5 42C29.5 42 47.9497 42 52.5513 40.7422C55.0897 40.0531 57.0881 38.0953 57.7686 35.5141C59 30.8219 59 21.0437 59 21.0437C59 21.0437 59 11.2656 57.7686 6.57344H57.7578ZM23.4617 29.925V12.1625L38.8761 21.0437L23.4617 29.925Z" fill="currentColor" />
// </svg>
// }

// const xIcon = () => {
//   return <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
//   <path d="M32.131 3.5H38.0709L25.0974 18.3245L40.3594 38.5H28.4123L19.0481 26.2668L8.34615 38.5H2.39784L16.2716 22.6406L1.64062 3.5H13.8906L22.3462 14.6815L32.131 3.5ZM30.0445 34.9495H33.3341L12.0986 6.86538H8.5649L30.0445 34.9495Z" fill="currentColor" />
// </svg>
// }

const stellaDetails = {
  YATO: {
    generation: '1기생',
    englishName: 'Yato',
    nameDisplay: {
      korean: '야토',
      japanese: 'ヤト',
    },
    description: [
      '모종의 이유로 숲속에 버려진 야토. 그를 발견한 것은 숲에 살던 토끼들이었다.\n 사람이 아닌 토끼들의 손에서 자라난 야토는, 그들의 가족이자 동료가 되어 함께 시간을 보냈다.\n 그러나 야토의 몸은 점점 커지고, 타고난 먹보 체질로 인해 토끼 무리는 유례없는 식량 부족에 시달리게 된다. 결국 토끼들은 야토에게 그녀가 토끼가 아닌 ‘사람’이라는 사실을 털어놓는다. 사실 야토도 성장하면서 자신이 다른 토끼들과 다르다는 것을 어렴풋이 느끼고 있었다. 하지만 그 진실을 직접 들은 순간, 야토는 깊은 충격에 빠진다. 그리고 호기심을 억누르지 못한 채, 산 아래의 마을로 몰래 발걸음을 옮긴다.\n 그러나 사람들의 손에 길러지지 않은 야토의 모습은 평범함과 거리가 멀었고, 마을 사람들의 시선은 냉담하기만 했다. 토끼도, 사람도 아닌 자신.\n 그 정체성을 찾고자 하는 간절한 염원이 마음속에서 피어오르는 순간—\n 야토의 몸에서 이상하고도 따뜻한 빛이 흘러나오기 시작했다',
    ],
    descriptionJP: [`ある事情により、森の中に捨てられたヤト。

      そんな彼を見つけたのは、森に暮らすうさぎたちだった。
      人ではない、うさぎたちの手で育てられたヤトは、
      やがて彼らの家族となり、仲間となり、共に日々を過ごしていく。

      しかし――ヤトの体は少しずつ大きくなり、
      生まれつきの大食い気質によって、うさぎたちはかつてない食糧不足に悩まされることになる。

      そしてついに、うさぎたちはヤトに告げた。

      “君は、うさぎではなく――人間なんだ”実はヤト自身も、成長するにつれて
      自分がみんなと違う存在であることを、どこかで感じていた。けれど、その真実をはっきりと突きつけられた瞬間、ヤトは深い衝撃を受ける。

      そして抑えきれない好奇心のまま、
      こっそり山のふもとの村へと足を踏み入れた。
      だが、人の手で育てられなかったヤトの姿は、
      “普通”とはほど遠かった。村人たちの視線は、ただ冷たかった。

      うさぎでもない、人間でもない。――自分は、何者なのか。
      その答えを求める強い願いが胸に芽生えた、その瞬間。
      ヤトの身体から、不思議であたたかな光があふれ始めた。
    `],
    platformLinks: {
      chzzk: 'https://chzzk.naver.com/e87999abca4fd0c3214e05ef414ce951',
      youtube: 'https://www.youtube.com/@yatoisyato',
      x: 'https://x.com/yatoisyato',
    },
    secondaryImage: '/RT/Yato_RT_20-1.png',
    backgroundColor: '#FFCA80',
    generationColor: '#FFAF3F',
    englishNameColor: '#FFEED5',
    youtubeURL: 'https://www.youtube.com/embed/gcWUnfYA0NY?si=nV6PYuHvG_aXEFim',
    profile: {
      items: [
        { label: '종족', value: '인간' },
        { label: '생일', value: '1월 18일' },
        { label: '팬네임', value: '마토' },
        { label: '나이', value: '17+@살' },
        { label: '데뷔', value: '2023년 6월 3일' },
      ],
      itemsJP: [
        { label: '種族', value: '人間' },
        { label: '誕生日', value: '1月18日' },
        { label: 'ファンネーム', value: 'マト' },
        { label: '年齢', value: '17歳+＠' },
        { label: 'デビュー', value: '2023年6月3日' },
      ],
    },
  },
  ODANMING: {
    generation: '2기생',
    englishName: 'Odanming',
    nameDisplay: {
      korean: '오단밍',
      japanese: 'オダンミン',
    },
    description: [
      '어릴 적부터 사랑의 요정에게 가장 중요한 덕목인 ‘소통’ 능력이 뛰어나, 단밍은 늘 주목받으며 자랐다. 하지만 취업난이 극심한 대한민국에서 살아남기란 결코 쉽지 않았다.\n 간신히 취업한 직장에서조차 그녀는 말단 직원이라는 이유로, 사랑의 화살 손질 같은 잡일만 떠맡게 된다.\n 단조로운 나날은 점점 무료함과 우울을 불러왔고,\n 그렇게 무기력에 잠식되어 가던 어느 날—\n 우연한 계기를 통해 단밍은 낯선 세계, 리스텔라로 불려가게 된다.'
    ],
    descriptionJP: [`幼い頃から、愛の妖精にとって最も大切な資質である「コミュニケーション能力」に優れていたダンミンは、常に周囲の注目を集めながら育った。
      しかし、就職難が深刻な韓国で生き抜くことは、決して簡単なことではなかった。

      ようやく就職した職場でも、末端の社員という理由で、愛の矢の手入れといった雑務ばかりを任される日々。
      単調な毎日は、次第に退屈さと憂鬱さを募らせていった。

      そして、無気力に蝕まれていったある日――
      思いがけない出来事をきっかけに、ダンミンは見知らぬ世界――リステラへと呼び寄せられる。
    `],
    platformLinks: {
      chzzk: 'https://chzzk.naver.com/f3b204dd3fd6925835ca1848cd4b6d3c',
      youtube: 'https://www.youtube.com/@odanming',
      x: 'https://x.com/odanming',
    },
    secondaryImage: '/placeholder-your-moon.png',
    backgroundColor: '#FFAAAC',
    generationColor: '#FA8E90',
    englishNameColor: '#FFDEDF',
    youtubeURL: 'https://www.youtube.com/embed/T-3X8V_m16U?si=hu_PKRippRlQB69e',
    profile: {
      items: [
        { label: '종족', value: '사랑의 요정' },
        { label: '생일', value: '6월 1일' },
        { label: '팬네임', value: '버리' },
        { label: '나이', value: '20살' },
        { label: '데뷔', value: '2024년 9월 15일' },
        // { label: '키', value: '162cm' },
      ],
      itemsJP: [
        { label: '種族', value: '愛の妖精' },
        { label: '誕生日', value: '6月1日' },
        { label: 'ファンネーム', value: 'バリ' },
        { label: '年齢', value: '20歳' },
        { label: 'デビュー', value: '2024年9月15日' },
      ],
    },
  },
  HAMKUBBY: {
    generation: '2기생',
    englishName: 'Hamkubby',
    nameDisplay: {
      korean: '햄쿠비',
      japanese: 'ハムクビ',
    },
    description: [
      '얼음 도깨비는 공포를 통해 반려 도깨비불을 만든다고 전해진다. 쿠비 역시 인간의 공포를 훔치기 위해 아랫마을로 내려갔지만, 그만 햄스터를 보고 겁에 질려 버리고 만다. 이 감정을 공포로 착각한 쿠비는, 엉뚱하게도 공포 대신 햄스터를 데려오는 만행을 저지른다. 결국 공포를 가져오지 못한 대가로 쿠비는 겉모습이 변하는 벌을 받게 되고,\n 그녀가 데려온 햄스터마저 도깨비불로 변해 버린다.\n 처음으로 ‘공포’라는 감정을 직접 경험한 쿠비는, 이후 인간이 가진 ‘감정’ 그 자체에 호기심을 품게 된다. 그리고 새로운 감정을 찾아 떠나기 위해 한밤중에 도망을 치고, 그 여정에서 리스텔라와 마주하게 된다.'
    ],
    descriptionJP: [`氷のトッケビは、“恐怖”を糧にして自分だけの伴侶となる鬼火を生み出すと伝えられている。
      クビもまた、人間の恐怖を奪うために麓の村へと降りていった。

      しかし、そこで見かけたハムスターに思わず怯えてしまう。
      その感情を“恐怖”だと勘違いしたクビは、なんと恐怖の代わりにハムスターを連れ帰ってしまうというとんでもない失敗を犯してしまった。

      結局、恐怖を持ち帰れなかった代償として、クビはその姿を変えられる罰を受け、
      さらには彼女が連れてきたハムスターまでも鬼火へと変えられてしまう。

      生まれて初めて「恐怖」という感情を自ら体験したクビは、
      それをきっかけに、人間が持つ“感情”そのものに強い興味を抱くようになる。

      そして、新たな感情を探し求めて真夜中に逃げ出した彼女は、
      その旅の途中でリステラと出会うことになる。  
    `],
    platformLinks: {
      chzzk: 'https://chzzk.naver.com/9351fb8417f73405c84e0846409e3263',
      youtube: 'https://www.youtube.com/@hamkubby',
      x: 'https://x.com/hamkubby',
    },
    secondaryImage: '/placeholder-hamkubby-media.png',
    backgroundColor: '#91AD94',
    generationColor: '#78987B',
    englishNameColor: '#C7EACB',
    youtubeURL: 'https://www.youtube.com/embed/ZDesMBnOclg?si=iE6K-7XizIwPLfCI',
    profile: {
      items: [
        { label: '종족', value: '얼음도깨비' },
        { label: '생일', value: '4월 12일' },
        { label: '팬네임', value: '햄님' },
        { label: '나이', value: '400살' },
        { label: '데뷔', value: '2024년 9월 15일' },
        // { label: '키', value: '154cm' },
      ],
      itemsJP: [
        { label: '種族', value: 'トッケビ' },
        { label: '誕生日', value: '4月12日' },
        { label: 'ファンネーム', value: 'ハム様' },
        { label: '年齢', value: '400歳' },
        { label: 'デビュー', value: '2024年9月15日' },
      ],
    },
  },
  YUNE: {
    generation: '3기생',
    englishName: 'Amiha Yune',
    nameDisplay: {
      korean: '아미하 유네',
      japanese: '網羽 ゆね',
    },
    description: [`
      수백 년 전, 누군가의 간절한 소망을 담아 만든 드림캐쳐에서 태어난 유네.
      유네는 깨어난 이후 사람들의 꿈 속을 오가며 흐름을 읽고, 현실과 꿈의 경계를 지키는 수호자로 살아왔다.
      유네에게 꿈은 생존을 위한 식량이었다.
      나쁜 꿈을 먹어 없애고, 좋은 꿈이 오래 머무를 수 있도록 지켜주는 역할을 이어왔다.
      하지만 시간이 흐르며 사람들은 바쁜 현실에 매달리게 되었고, 꿈꾸는 일조차 점점 잊어갔다.
      사라져가는 꿈들과 함께 유네의 힘도 점점 약해지고, 존재마저 희미해져 가던 어느 날.
      어둠 속에서 하나의 빛이 유네를 부른다.
      그 빛을 따라간 끝에 유네는 리스텔라의 문 앞에 도착하고,
      그곳에서 다시 한 번 자신이 머물 이유를 발견하게 된다.
    `],
    descriptionJP: [`
      数百年前、誰かの切なる願いを込めて作られたドリームキャッチャーから生まれた『ユネ』。

      目覚めて以来、人々の夢の中を渡り歩きながらその流れを見守り、現実と夢の境界を守る存在として生きてきた。

      『ユネ』にとって夢は、生きるための糧だった。

      悪い夢を食べて消し去り、良い夢が少しでも長く留まれるよう見守る――そんな役目を果たし続けてきた。

      しかし時が流れるにつれ、人々は忙しい現実に追われるようになり、夢を見ることさえ少しずつ忘れていった。

      消えゆく夢とともに『ユネ』の力も弱まり、その存在さえも薄れ始めていたある日。

      暗闇の中で、一筋の光が『ユネ』を呼んだ。

      その光を追いかけた先で、『ユネ』はリステラの扉の前へと辿り着く。

      そしてそこで、もう一度――自分がこの世界に留まる理由を見つけることになる。
    `],
    platformLinks: {
      chzzk: 'https://chzzk.naver.com/dd6cf0d465dae40bc4a83f78abd58352',
      youtube: 'https://www.youtube.com/@%EC%95%84%EB%AF%B8%ED%95%98%EC%9C%A0%EB%84%A4',
      x: 'https://x.com/listella_yune',
    },
    secondaryImage: '/placeholder-hamkubby-media.png',
    backgroundColor: '#9047d6',
    generationColor: '#b3a7eb',
    englishNameColor: '#b3a7eb',
    youtubeURL: 'https://www.youtube.com/watch?v=cpeHZcxgHMI',
    profile: {
      items: [
        { label: '종족', value: '꿈의 정령' },
        { label: '생일', value: '3월 17일' },
        { label: '팬네임', value: '몽치' },
        { label: '나이', value: '셀 수 없음' },
        { label: '데뷔', value: '2026년 5월 25일' },
        // { label: '키', value: '154cm' },
      ],
      itemsJP: [
        { label: '種族', value: '夢の精霊' },
        { label: '誕生日', value: '3月 17日' },
        { label: 'ファンネーム', value: 'モンチ' },
        { label: '年齢', value: '数えきれない' },
        { label: 'デビュー', value: '2026年5月25日' },
      ],
    },
  },
  DORI: {
    generation: '3기생',
    englishName: 'Shokoko Dori',
    nameDisplay: {
      korean: '쇼코코 도리',
      japanese: '証幸子 どり',
    },
    description: [`
      너구리 탐정 고등학교에 다니는 도리는 둔갑술에 영 소질이 없어 돌로만 변신하는 탐정 지망생이다.
      엉뚱한 추리와 허당미 넘치는 성격 때문에 매번 낙제점만 받는다.
      언젠가 인정받고 싶었던 도리는 마을의 작은 사건을 해결하겠다며 잠복 수사에 나섰다가, 돌로 변신한 채 그대로 잠들어버린다.
      마침 산책 중이던 에테는 길가에 있는 돌을 자신의 애완돌과 착각하고, 아무 의심 없이 돌이 된 도리를 루체테 도서관으로 데려가 버린다.
      한참 뒤 깨어난 도리는 상황을 수습하려고 아무 말 추리를 던졌는데, 그게 기막히게도 사건의 정답과 정확히 일치해버린다.
      생애 처음으로 타인에게 “탐정님”이라 불린 순간이었다.
      자신감을 얻은 도리는 의기양양하게 외쳤다.
      “코난 같은 명탐정 스텔라… 제가 하겠습니다!”
      그렇게 도리는 리스텔라에 합류하게 된다.
    `],
    descriptionJP: [`
      タヌキ探偵高校に通う『どり』は、変化の術が大の苦手で、石にしか化けられない探偵志望の少女。

      突拍子もない推理とどこか抜けた性格のせいで、成績はいつも落第点ばかりだった。

      いつか周囲に認められたい――そんな思いを胸に、村で起きる小さな事件を解決しようと張り込み捜査に挑む。

      しかし、石に化けたままその場で眠り込んでしまうという大失態を犯してしまった。

      ちょうどその頃、散歩をしていたエテは道端に落ちていたその石を自分のペットストーンと勘違いし、何の疑いもなく石になった『どり』をルチェテ図書館へ持ち帰ってしまう。

      しばらくして目を覚ました『どり』は、その場を取り繕おうと適当な推理を口にした。

      ところが、その推理が驚くことに事件の真相と完全に一致していたのだ。

      生まれて初めて、誰かに「探偵さん」と呼ばれた瞬間だった。

      自信を手にした『どり』は、胸を張ってこう宣言する。

      「コナンみたいな名探偵ステラ……私がなります！」

      そしてそのまま、『ドリ』はリステラの仲間に加わることとなった。
    `],
    platformLinks: {
      chzzk: 'https://chzzk.naver.com/cb0ceb32cbf6bced3bac7892cbca37e1',
      youtube: 'https://www.youtube.com/@%EC%87%BC%EC%BD%94%EC%BD%94%EB%8F%84%EB%A6%AC',
      x: 'https://x.com/listella_dori',
    },
    secondaryImage: '/placeholder-hamkubby-media.png',
    backgroundColor: '#f8d2d8',
    generationColor: '#68686a',
    englishNameColor: '#68686a',
    youtubeURL: 'https://www.youtube.com/watch?v=cpeHZcxgHMI',
    profile: {
      items: [
        { label: '종족', value: '너구리수인' },
        { label: '생일', value: '8월 28일' },
        { label: '팬네임', value: '돌돌이' },
        { label: '나이', value: '18살' },
        { label: '데뷔', value: '2026년 5월 25일' },
        // { label: '키', value: '154cm' },
      ],
      itemsJP: [
        { label: '種族', value: 'タヌキ人間' },
        { label: '誕生日', value: '8月 28日' },
        { label: 'ファンネーム', value: 'ドルドリ' },
        { label: '年齢', value: '18歳' },
        { label: 'デビュー', value: '2026年5月25日' },
      ],
    },
  },
  FUWA: {
    generation: '3기생',
    englishName: 'Hakuten Fuwa',
    nameDisplay: {
      korean: '하쿠텐 후와',
      japanese: '白貂 ふわ',
    },
    description: [`
      백귀야행이 일상처럼 이어지는 세계.
      인간과 요괴의 경계에 세워진 신사에서 후와는 늙은 음양사의 스승에게 구조되어, 강한 영력을 제어하기 위해 매일 술식과 결계를 수련하고 있다.
      후와의 곁에는 요수의 피를 이은 반령 텐비가 항상 함께했다. 두 사람은 수련과 생활을 나누며 깊은 유대를 쌓아갔다.
      하지만 어느 날 텐비가 사라지고, 후와는 요괴가 가득한 눈산으로 향한다.
      마침내 텐비를 찾아 귀환술을 시도하지만, 술식은 예상치 못한 빛의 균열을 만들어낸다.
      눈을 뜬 곳은 수많은 책이 늘어선 낯선 도서관.
      그곳에서 음양사 후와의 새로운 이야기가 시작된다.
    `],
    descriptionJP: [`
      百鬼夜行が日常のように続く世界。

      人と妖怪の境界に建つ神社で、『フワ』は年老いた陰陽師の師匠に救われ、生まれ持った強い霊力を制御するため、毎日術式と結界の修行に励んでいた。

      『フワ』のそばには、妖獣の血を引く半霊のテンビがいつも寄り添っていた。修行の日々も、何気ない暮らしも共に過ごし、二人の絆は少しずつ深まっていく。

      しかし、ある日突然テンビは姿を消してしまう。

      テンビを探すため、『フワ』は妖怪たちがひしめく雪山へと足を踏み入れた。

      長い旅の末にようやくテンビを見つけ出し、帰還の術を発動する。

      だが、その術式は予想もしなかった光の亀裂を生み出してしまう。

      次に目を覚ました場所は、無数の本が並ぶ見知らぬ図書館だった。

      ――そこで、陰陽師『フワ』の新たな物語が幕を開ける。
    `],
    platformLinks: {
      chzzk: 'https://chzzk.naver.com/7792c631f74f66e92ae25949a3a11abb',
      youtube: 'https://www.youtube.com/@%ED%95%98%EC%BF%A0%ED%85%90%ED%9B%84%EC%99%80',
      x: 'https://x.com/listella_fuwa',
    },
    secondaryImage: '/placeholder-hamkubby-media.png',
    backgroundColor: '#4db6f5',
    generationColor: '#adcbe8',
    englishNameColor: '#adcbe8',
    youtubeURL: 'https://www.youtube.com/watch?v=cpeHZcxgHMI',
    profile: {
      items: [
        { label: '종족', value: '인간(음양사)' },
        { label: '생일', value: '2월 26일' },
        { label: '팬네임', value: '텐비' },
        { label: '나이', value: '300살' },
        { label: '데뷔', value: '2026년 5월 25일' },
        // { label: '키', value: '154cm' },
      ],
      itemsJP: [
        { label: '種族', value: '人間（陰陽師)' },
        { label: '誕生日', value: '2月 26日' },
        { label: 'ファンネーム', value: 'テンビ' },
        { label: '年齢', value: '300歳' },
        { label: 'デビュー', value: '2026年5月25日' },
      ],
    },
  },
};

const StellaDetails = () => {
  const { currentLocale } = useLocale();
  
  const { name } = useParams();
  const navigate = useLocaleNavigate();
  const { stella } = useStella();

  // 대각선 기준값: 768~1279px 구간 선형 보간
  const [viewportW, setViewportW] = useState(() => window.innerWidth);

  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const diagonalClipPath = useMemo(() => {
    // 1280px 이상: "수정 이전" 데스크탑 고정값 유지
    if (viewportW >= 1280) {
      return `polygon(
        0% 1128px,
        100% 985.33px,
        100% 0%,
        0% 0%
      )`;
    }

    // 768~1279px: 선형 보간 (1279->2883/2661, 768->1962/1805)
    const minW = 344;
    const maxW = 1279;
    const clamp01 = (v) => Math.max(0, Math.min(1, v));
    const t = clamp01((viewportW - minW) / (maxW - minW));

    const leftMin = 930;
    const leftMax = 2883;
    const rightMin = 833.5;
    const rightMax = 2661;

    const leftY = leftMin + (leftMax - leftMin) * t;
    const rightY = rightMin + (rightMax - rightMin) * t;

    return `polygon(
      0% ${leftY.toFixed(2)}px,
      100% ${rightY.toFixed(2)}px,
      100% 0%,
      0% 0%
    )`;
  }, [viewportW]);

  const minW = 768;
  const maxW = 1279;
  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const t = clamp01((viewportW - minW) / (maxW - minW));
  // w=768 => 72, w=1279 => 112 (선형 보간)
  const tabletSPadding = 72 + (112 - 72) * t;
  // URL 파라미터를 대문자로 변환하여 캐릭터 이름과 매칭
  const stellaName = name?.toUpperCase();
  const stellar = stella[stellaName];
  const details = stellaDetails[stellaName];

  if (!stellar || !details) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] text-white">
        <div className="text-center">
          <h1 className="text-2xl mb-4">스텔라를 찾을 수 없습니다</h1>
          <button
            onClick={() => navigate('/home#4')}
            className="px-4 py-2 bg-gray-700 rounded hover:bg-gray-600 transition-colors"
          >
            홈으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  // 캐릭터 기본 정보와 상세 정보 병합
  const fullStellaData = {
    ...stellar,
    ...details,
  };

  const stellaColor = fullStellaData.backgroundColor || '#2F2629';
  const generationColor = fullStellaData.generationColor || '#FFAF3F';

  // 캐릭터별 이미지 경로 매핑
  const stellaImageMap = {
    YATO: '/stella_image/yato.png',
    // ODANMING: '/stella_image/odanming.png',
    ODANMING: '/stella_image/odanming.png',
    HAMKUBBY: '/stella_image/kubby.png',
    YUNE: '/stella_image/yune.png',
    DORI: '/stella_image/dori.png',
    FUWA: '/stella_image/fuwa.png',
    NIU: '/stella_image/niu.png',
  };
  const stellaImage = stellaImageMap[stellaName] || '/stella_image/yato.png';

  const DetailContent = (
    <div className="w-full flex flex-col gap-[48px] tabletS:gap-[96px] web:gap-[40px] ">
      {/* 소개 라인 + 텍스트 */}
      <div className="flex flex-col gap-6">
        <div className="flex flex-row items-center gap-6 w-full web:w-[calc(100%+158px)] web:-mx-[79px]">
          <img
            src="/section-line.webp"
            alt=""
            aria-hidden="true"
            className="w-0 flex-1 h-[14px] object-contain"
          />
          <img
            src="/pv-marker.png"
            alt="pv-marker"
            className="shrink-0 w-[60px] h-[60px] tabletS:w-[100px] tabletS:h-[100px] web:w-[70px] web:h-[70px]"
          />
          <img
            src="/section-line2.webp"
            alt=""
            aria-hidden="true"
            className="w-0 flex-1 h-[14px] object-contain rotate-180"
          />
        </div>
      </div>

      <div className={clsx("text-white leading-[1.7] font-paperozi font-medium whitespace-pre-line",
        "text-[20px] tabletS:text-[38px] web:text-[20px]",
        "px-9 tabletS:px-16 web:px-0")}>
        {
          currentLocale.value === 'ko'
          ? Array.isArray(fullStellaData.description) && fullStellaData.description.map((line, idx) => <p key={idx}>{line}</p>)
          : Array.isArray(fullStellaData.descriptionJP) && fullStellaData.descriptionJP.map((line, idx) => <p key={idx}>{line}</p>)
        }
        
      </div>

      {fullStellaData.youtubeURL && (
        <div className="flex justify-center px-9 tabletS:px-16 web:px-0">
          <div className="z-50 aspect-video w-full rounded-[20px] tabletS:rounded-[40px] overflow-hidden">
            <iframe
              width="100%"
              height="100%"
              src={fullStellaData.youtubeURL.replace('watch?v=', 'embed/')}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );

  const platformContent = (
  <div
    className={clsx("inline-flex flex-row justify-between items-center",
      "bg-white rounded-full",
      "px-[16px] tabletS:px-[36px] web:px-[28px]",
      "py-[8px] tabletS:py-[18px] web:py-[14px]",
      "gap-[14px] tabletS:gap-7 web:gap-6")}
    style={{ color: stellaColor }}
    aria-label="platform links"
  >
    {/* chzzk */}
    <a
      href={fullStellaData.platformLinks?.chzzk}
      target="_blank"
      rel="noreferrer"
      aria-label="치지직"
      className="inline-flex"
    >
      <div className={clsx("flex items-center justify-center",
        "w-[20px] tabletS:w-[59px] web:w-[42px]",
        "h-[20px] tabletS:h-[59px] web:h-[42px]")}>
      {chzzkColorIcon()}
      </div>
    </a>
    {/* youtube */}
    <a
      href={fullStellaData.platformLinks?.youtube}
      target="_blank"
      rel="noreferrer"
      aria-label="유튜브"
      className="inline-flex"
    >
      <div className={clsx("flex items-center justify-center",
        "w-[27px] tabletS:w-[67.46px] web:w-[59px]",
        "h-[19px] tabletS:h-[47.43px] web:h-[42px]")}>
        {youtubeColorIcon()}
      </div>
    </a>
    {/* x */}
    <a
      href={fullStellaData.platformLinks?.x}
      target="_blank"
      rel="noreferrer"
      aria-label="X"
      className="inline-flex"
    >
      <div className={clsx("flex items-center justify-center",
        "w-[20px] tabletS:w-[59px] web:w-[42px]",
        "h-[20px] tabletS:h-[59px] web:h-[42px]")}>
        {xColorIcon()}
      </div>
    </a>
  </div>)

  return (
    <div className="h-screen text-white bg-[#2F2629] overflow-y-auto overflow-x-hidden">
      {/* 스크롤 컨텐츠 전체 높이를 기준으로 대각선 고정 */}
      <div className="relative min-h-full">
        {/* 대각선 배경 오버레이 */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundColor: stellaColor,
            clipPath: diagonalClipPath,
            WebkitClipPath: diagonalClipPath,
          }}
        />
        <main className="relative z-10 web:px-9">
          <section className="flex justify-center">
            <div className="flex flex-col web:flex-row justify-between pt-[118px] max-w-[1460px] w-full web:gap-9">
              {/* 1280px 이하: 정보가 위 / 이미지가 아래 */}
              <div className="relative order-2 web:order-1 w-full web:w-[510px] shrink-0 flex flex-col items-center pt-[40px] tabletS:pt-[80px] web:pt-0">
                <figure className="w-full web:h-[1338px] flex justify-center items-start px-4 tabletS:px-6 web:px-0">
                  <img
                    src={stellaImage}
                    alt={stellaName}
                    className="object-fill web:object-none web:object-top overflow-visible"
                  />
                </figure>

                {/* 1280px 이하: 소개/영상은 이미지 아래 */}
                <div className="pt-[88px] tabletS:pt-[220px] w-full web:hidden">
                  {DetailContent}
                </div>
              </div>
              
              <div
                className="order-1 web:order-2 flex flex-col flex-1 min-w-0 max-w-[760px] gap-16 pl-[40px] tabletS:pl-0"
                style={{
                  paddingLeft: viewportW >= 768 && viewportW <= 1279 ? `${tabletSPadding}px` : undefined,
                }}
              >
                {/* 상단 정보 시작 */}
                <div className="web:mt-32 flex flex-col gap-2">
                  {/* <div className="w-full flex flex-row justify-start">
                    <div
                      className="rounded-full flex items-center justify-center"
                      style={{ backgroundColor: generationColor }}
                    >
                      <p className={clsx("text-white font-paperozi font-semibold",
                        "web:font-medium text-[14px] tabletS:text-[36px] web:text-[24px]",
                        "px-[14px] tabletS:px-[42px] web:px-6",
                        "py-[8px] tabletS:py-[20px] web:py-[10px]")}>{fullStellaData.generation}</p>
                    </div>
                  </div> */}
                  <div className="flex flex-col gap-2 tabletS:gap-4 web:gap-0 ">
                      <div className="flex flex-col gap-0">
                    <div className="w-full flex flex-row justify-between items-start">
                        <p className={clsx("text-white leading-[1.2] font-paperozi font-extrabold break-keep",
                          "text-[56px] tabletS:text-[130px] web:text-[68px]"
                        )}>
                          
                          {currentLocale.value === 'ko' ? fullStellaData.nameDisplay.korean : fullStellaData.nameDisplay.japanese}
                        </p>

                        {/* 1280px 이상: 플랫폼 아이콘(틀) */}
                        <div className="hidden web:block">
                          {platformContent}
                        </div>

                        </div>

                        <p className="text-[20px] tabletS:text-[48px] web:text-[24px] leading-[1.5] font-paperozi font-medium px-2"
                          style={{ color: fullStellaData.englishNameColor }}>
                            {fullStellaData.englishName}
                        </p>
                      </div>

                    {/* 1280px 이하: 플랫폼 아이콘(틀) */}
                    <div className="flex web:hidden">
                      {platformContent}
                    </div>
                  </div>
                </div>
                {/* 상단 정보 끝 */}

                {/* 1280px 이상: 소개/영상은 우측 정보 영역 */}
                <div className="hidden web:block">
                  {DetailContent}
                </div>
              </div>
            </div>
          </section>

        {/* PROFILE 섹션(틀) */}
          <section className={clsx("flex justify-center",
            "pt-[42px] tabletS:pt-[96px] web:pt-[120px]",
            "pb-[140px]")}>
            <div className="flex flex-col items-center justify-center w-[770px]">
              <div className="flex flex-row items-center gap-6 w-full web:w-[calc(100%+158px)] web:-mx-[79px]">
                <img
                  src="/section-line.webp"
                  alt=""
                  aria-hidden="true"
                  className="w-0 flex-1 web:h-[14px] h-[18px] object-contain"
                />
                <img
                  src="/pv-marker.png"
                  alt="section-marker"
                  className="shrink-0 w-[60px] h-[60px] tabletS:w-[100px] tabletS:h-[100px] web:w-[70px] web:h-[70px]"
                />
                <img
                  src="/section-line2.webp"
                  alt=""
                  aria-hidden="true"
                  className="w-0 flex-1 web:h-[14px] h-[18px] object-contain rotate-180"
                />
              </div>

              <h2 className={clsx("text-center text-white font-paperozi font-extrabold leading-[1.5]",
                "pt-[24px] tabletS:pt-[48px] web:pt-[36px]",
                "text-[30px] tabletS:text-[90px] web:text-[48px]")}>
                PROFILE
              </h2>

              <dl className={clsx("flex flex-col gap-7",
                "w-[363px] tabletS:w-[769px] web:w-[500px]",
                "pt-[42px] tabletS:pt-[96px] web:pt-[48px]",
                "px-[36px] tabletS:px-[64px] web:px-0")}>
                {fullStellaData.profile[currentLocale.value === 'ko' ? 'items': 'itemsJP'].length === 0 
                ? (<div className={(clsx("flex flex-row items-center gap-2 tabletS:gap-6 web:gap-3",
                      "tabletS:w-[652px] web:w-auto",
                    ))}>
                    <div className={clsx("flex flex-row justify-center font-paperozi leading-[1.5] w-full items-center justify-start",
                      "text-[20px] tabletS:text-[48px] web:text-[24px]",
                      "gap-[18px] tabletS:gap-9 web:gap-9",
                      "pt-[6px] tabletS:pt-[12px] web:pt-[8px]",
                      "pb-[10px] tabletS:pb-[14px] web:pb-[10px]")}>
                      <span className="text-white font-medium whitespace-nowrap">
                        준비중
                      </span>
                    </div>
                </div>)
                : fullStellaData.profile[currentLocale.value === 'ko' ? 'items': 'itemsJP']?.map(({ label, value }, idx) => (
                  <div key={`${label}-${idx}`}
                    className={(clsx("flex flex-row items-center gap-2 tabletS:gap-6 web:gap-3",
                      "tabletS:w-[652px] web:w-auto",
                    ))}>
                    <div className={clsx("flex items-center justify-center",
                      "w-[24px] tabletS:w-[30px] web:w-[30px]",
                      "h-[24px] tabletS:h-[30px] web:h-[30px]")}>
                      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M30.0008 56.9391C29.5711 56.9391 29.2015 56.5867 29.0725 56.0795L24.4481 36.9889L9.25991 31.1698C8.85592 31.0151 8.57227 30.5423 8.57227 30.0008C8.57227 29.4593 8.84732 28.9951 9.25991 28.8318L24.4481 23.0126L29.0725 3.92205C29.1929 3.40632 29.5711 3.0625 30.0008 3.0625C30.4306 3.0625 30.8002 3.41492 30.9291 3.92205L35.5535 23.0126L50.7418 28.8318C51.1458 28.9865 51.4294 29.4593 51.4294 30.0008C51.4294 30.5423 51.1544 31.0065 50.7418 31.1698L35.5535 36.9889L30.9291 56.0795C30.8088 56.5867 30.4306 56.9391 30.0008 56.9391Z" fill="white"/>
                        <path d="M30.0023 55.7212L25.2232 36.0117L9.53641 30.0035L25.2232 23.9952L30.0023 4.28577L34.7814 23.9952L50.4682 30.0035L34.7814 36.0117L30.0023 55.7212Z" fill="white"/>
                      </svg>

                    </div>
                    <div className={clsx("flex flex-row font-paperozi leading-[1.5] w-full items-center justify-start shadow-[inset_0_-3.26px_0_0_#696365]",
                      "text-[20px] tabletS:text-[24px] web:text-[24px]",
                      "gap-[18px] tabletS:gap-9 web:gap-9",
                      "pt-[6px] tabletS:pt-[12px] web:pt-[8px]",
                      "pb-[10px] tabletS:pb-[14px] web:pb-[10px]")}>
                      <dt
                        className="font-bold w-[72px] tabletS:w-[160px] web:w-[72px]"
                        style={{ color: stellaColor }}
                      >
                        {label}
                      </dt>
                      <dd className="text-white font-medium whitespace-nowrap">
                        {value}
                      </dd>
                    </div>
                  </div>
                ))}
              </dl>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default StellaDetails;
